import { Component, input, OnInit, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { filter } from 'rxjs';
import { ConvertToBytesPipe } from 'src/app/pipes/convert-to-bytes.pipe';

@Component({
  selector: 'app-file-upload-container',
  templateUrl: './file-upload-container.component.html',
  styleUrls: ['./file-upload-container.component.scss'],
  imports: [ReactiveFormsModule, MatTooltipModule, MatIconModule, MatButtonModule, ConvertToBytesPipe]
})
export class FileUploadContainerComponent implements OnInit {
  readonly formGroup = input.required<FormGroup>();
  readonly controlName = input.required<string>();
  readonly accept = input<string>('*/*');
  readonly showUploadBtn = input<boolean>(true);
  readonly uploadAttachmentEmitter = output<Event>();

  file: File = {} as File;
  ngOnInit(): void {
    this.formGroup()
      .get(this.controlName())
      ?.valueChanges.pipe(filter((change) => change === ''))
      .subscribe(() => {
        this.file = {} as File;
      });
  }

  onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    if (file) {
      this.file = file;
      const formData = new FormData();
      formData.append('attachment', file);
      this.formGroup().get(this.controlName())?.setValue(formData);
    }
  }

  uploadAttachment(): void {
    if (!this.file?.name || this.file.name.length === 0 || this.formGroup().get(this.controlName())?.value === null) {
      return;
    }
    const event = new CustomEvent('upload', { detail: this.file });
    this.uploadAttachmentEmitter.emit(event as unknown as Event);
  }
}
